import { BulletinUpdateFormValues } from './schema';
import { BulletinUpdate } from './types';

export const mapBulletinUpdateToFormValues = (
  bulletinUpdate: BulletinUpdate,
): BulletinUpdateFormValues => ({
  useFullValidation: false,
  id: bulletinUpdate.id,
  recipientTarget: bulletinUpdate.recipientTarget,
  investorIds: bulletinUpdate.investorIds,
  deliveryMethod: bulletinUpdate.deliveryMethod,
  subject: bulletinUpdate.subject,
  title: bulletinUpdate.title,
  commentary: bulletinUpdate.commentary,
  attachments: bulletinUpdate.attachments,
  attachmentMode: bulletinUpdate.attachmentMode,
  includeUkFinancialPromotionsNotice:
    bulletinUpdate.includeUkFinancialPromotionsNotice,
  resendPublishedUpdates: false,
});

export const mapFormValuesToSaveInput = (
  bulletinUpdate: BulletinUpdate,
  formValues: BulletinUpdateFormValues,
) => ({
  id: formValues.id ?? bulletinUpdate.id,
  vehicleId: bulletinUpdate.vehicleId,
  status: bulletinUpdate.status,
  recipientTarget: formValues.recipientTarget,
  investorIds: formValues.investorIds,
  deliveryMethod: formValues.deliveryMethod,
  subject: formValues.subject,
  title: formValues.title,
  commentary: formValues.commentary,
  attachments: formValues.attachments.map((attachment) => ({
    name: attachment.name,
    path: attachment.path,
    assignedInvestorIds: attachment.assignedInvestorIds,
  })),
  attachmentMode: formValues.attachmentMode,
  includeUkFinancialPromotionsNotice:
    formValues.includeUkFinancialPromotionsNotice,
  resendPublishedUpdates: formValues.resendPublishedUpdates,
});
